import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse } from '@tcc-mono/shared/data-access';
import { Company, Stable } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService<Company> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/relations'
  }

  public getStables = (companyId: string | number, params?: Params) => {
    return this.getChild(companyId, 'stables', params) as Observable<PaginatedResponse<Stable>>;
  }
}
